export default __webpack_public_path__ + "static/media/ThingsThatSting_01.0acc5c78.png";